import * as yup from 'yup';

export const CreateEditSiteValidationSchema = yup.object().shape({
	siteName: yup.string().trim().required('Site name is required'),
	description: yup.string().trim().required('Description is required'),
});
